define('formkit/view/block/design.form.object.menu.view',['require','exports','module','uikit/uikit','../form/form.object.type.menu/form.object.type.menu.composite.view','../../behavior/form.object.menu.drag.drop.behavior'],function(require, exports, module) {
  var UIKit = require('uikit/uikit');
  var FormObjectMenuCompositeView = require('../form/form.object.type.menu/form.object.type.menu.composite.view');
  var FormObjectMenuDragDropBehavior               = require('../../behavior/form.object.menu.drag.drop.behavior');


  var DesignFormObjectMenuBlockView = UIKit.CollectionView.extend({

    options: {
      form: null
    },

    childView: FormObjectMenuCompositeView.extend({
      behaviors: {
        DragDrop: {
          isContainer: false,
          behaviorClass: FormObjectMenuDragDropBehavior
        }
      },
    }),
    childViewOptions: function() {
      return {
        form: this.form,
        bindings: {
          headerText: 'name',
          collection: 'collection'
        }
      }
    },

    initialize: function() {
      UIKit.CollectionView.prototype.initialize.apply(this, arguments);

      if (this.form) {
        this.collection = this.form.getTemplateObjectTypeGroupCollection()
      }
    }
  });
  module.exports = DesignFormObjectMenuBlockView;
});

